import { useIonActionSheet, useIonToast } from '@ionic/react';
import { useHistory } from 'react-router';
import { useCreatePostMutation } from '../api/PostApi';
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces';
import { getEmptyPost } from '../util/getEmptyPost';
import { useCallback } from 'react';
import { useLoggedIn } from './useLoggedIn.js';
import { PostTypes } from 'model';
import { isMutationError } from '../util/error.js';

export interface PostCreateOption {
	text: string;
	data: {
		action: string;
	};
	role?: string;
}

export function usePostCreateActionSheet(header: string = 'Create A New') {
	const [presentPostCreateOptions] = useIonActionSheet();
	const history = useHistory();
	const [createPost] = useCreatePostMutation();
	const { realUser, loggedIn } = useLoggedIn();
	const [toast] = useIonToast();

	return useCallback(() => {
		const buttons = [
			{
				text: 'Post',
				data: {
					action: 'basic'
				}
			},
			{
				text: 'Item For Sale',
				data: {
					action: 'marketplaceItem'
				}
			},
			{
				text: 'Event',
				data: {
					action: 'event'
				}
			},
			{
				text: 'Poll',
				data: {
					action: 'poll'
				}
			},
			{
				text: 'Community Question',
				data: {
					action: 'communityQuestion'
				}
			},
			{
				text: 'Cancel',
				role: 'cancel',
				data: {
					action: 'cancel'
				}
			}
		];
		const goToCreatePage = async (postType: PostTypes) => {
			if (!loggedIn || !realUser) {
				history.push('/main/settings/login');
				return;
			}
			switch (postType) {
				case 'marketplaceItem':
				case 'basic':
				case 'event':
				case 'poll':
					{
						const result = await createPost({
							post: getEmptyPost(postType)
						});
						if (isMutationError(result)) {
							toast({
								color: 'danger',
								message: (result as { error: { data: string; status: number } }).error.data,
								position: 'top',
								duration: 2000
							});
						} else {
							history.push(`/main/latest/${postType}/edit/` + result.data._id);
						}
					}
					break;
				case 'communityQuestion':
					history.push(`/main/communityQuestion/#`);
					break;
			}
		};
		presentPostCreateOptions({
			header,
			buttons,
			onDidDismiss: ({ detail }: CustomEvent<OverlayEventDetail>) =>
				detail?.data?.action && goToCreatePage(detail.data.action)
		});
	}, [header, loggedIn, presentPostCreateOptions, createPost, history, realUser, toast]);
}
